<template>
  <v-container class="pa-0" fluid>
    <v-row :dense="!$vuetify.breakpoint.mobile">
      <!-- process -->
      <v-col cols="12" lg="4" xl="3" order-lg="last">
        <process-flow-card
          ref="sticky"
          v-model="internalFlow"
          :flow-items="flowItems"
          :selectable="flowSelectable"
          :loading="loading"
          :disabled="disabled"
          outlined
          @change="$emit('change:flow', $event)"
        />
      </v-col>

      <!-- details -->
      <v-col cols="12" lg="8" xl="9">
        <card-model-details
          :loading="loading"
          :disabled="disabled"
          v-bind="$attrs"
          v-on="$listeners"
        >
          <!-- passthrough slots -->
          <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
          <template
            v-for="(_, name) in $scopedSlots"
            :slot="name"
            slot-scope="slotData"
          >
            <slot :name="name" v-bind="slotData" />
          </template>

          <template #edit>
            <slot name="edit-prepend" />

            <process-flow-stepper
              v-model="internalFlow"
              :flow-items="flowItems"
              :selectable="flowSelectable"
            >
              <!-- passthrough slots -->
              <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
              <template
                v-for="(_, name) in $scopedSlots"
                :slot="name"
                slot-scope="slotData"
              >
                <slot :name="name" v-bind="slotData" />
              </template>
            </process-flow-stepper>

            <slot name="edit-append" />
          </template>

          <template #create>
            <slot name="create-prepend" />

            <process-flow-stepper
              v-model="internalFlow"
              :flow-items="flowItems"
              :selectable="flowSelectable"
            >
              <!-- passthrough slots -->
              <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
              <template
                v-for="(_, name) in $scopedSlots"
                :slot="name"
                slot-scope="slotData"
              >
                <slot :name="name" v-bind="slotData" />
              </template>
            </process-flow-stepper>

            <slot name="create-append" />
          </template>
        </card-model-details>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardModelDetails from './CardModelDetails'
import ProcessFlowCard from './ProcessFlowCard'
import ProcessFlowStepper from './ProcessFlowStepper'

export default {
  name: 'CardProcessDetails',

  components: {
    CardModelDetails,
    ProcessFlowCard,
    ProcessFlowStepper
  },

  inheritAttrs: false,

  props: {
    flow: {
      type: String,
      required: false,
      default: null
    },

    // see "ProcessFlowCard" component
    flowItems: {
      type: Array,
      required: false,
      default: null
    },

    flowSelectable: {
      type: Boolean,
      required: false,
      default: false
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      internalMode: 'VIEW',
      internalFlow: null
    }
  },

  watch: {
    flow: {
      handler(flow) {
        this.internalFlow = flow
      },
      immediate: true
    },

    internalFlow: {
      handler(flow) {
        this.$emit('update:flow', flow)
      },
      immediate: true
    }
  },

  mounted() {
    setTimeout(this.updateStickyPosition, 1000)
    window.addEventListener('resize', this.updateStickyPosition)
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateStickyPosition)
  },

  methods: {
    updateStickyPosition() {
      const el = this.$refs.sticky.$el
      if (el) {
        const bounding = el.getBoundingClientRect()
        const parentBounding = el.parentElement.getBoundingClientRect()
        const parentBoundingY = parentBounding.y
        const scrollTop = document.documentElement.scrollTop
        const boundingY = bounding.y
        const boundingHeight = bounding.height
        const windowHeight = window.innerHeight

        if (boundingHeight + boundingY + scrollTop < windowHeight) {
          el.style.position = 'sticky'
          el.style.top = `${scrollTop + parentBoundingY + 4}px`
        } else {
          el.style.position = null
          el.style.top = null
        }
      }
    }
  }
}
</script>
